import { createContext, useContext } from "react";
/** Breakpoint from which the surrounding info bar keeps all its content on one row */
const InfoBarLayoutContext = createContext("md");
export const InfoBarLayoutProvider = InfoBarLayoutContext.Provider;

/** @returns The breakpoint from which the surrounding info bar is a single row */
export function useInfoBarSingleRowFrom() {
  return useContext(InfoBarLayoutContext);
}